'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function hookFunction(oldFunction, newFunction) {
  return function(...args) {
    newFunction.call(this, ...args);
    if (oldFunction) {
      return oldFunction.call(this, ...args);
    }
  };
}

exports.hookFunction = hookFunction;
